import { Link } from 'react-router-dom';

export default function Footer() {
	const year = new Date().getFullYear();
	return (
		<footer className='border-t border-blue-900/30 bg-slate-950'>
			<div className='mx-auto max-w-6xl px-6 py-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6'>
				<div>
					<div className='font-display text-lg font-semibold text-white'>
						Asmakam LLC
					</div>
					<div className='text-sm text-blue-200/60'>
						© {year} Asmakam LLC. All rights reserved.
					</div>
				</div>
				<nav className='flex gap-6 text-sm text-blue-100'>
					<Link to='/privacy' className='hover:text-blue-400 focus-ring'>
						Privacy
					</Link>
					<Link to='/terms' className='hover:text-blue-400 focus-ring'>
						Terms
					</Link>
				</nav>
			</div>
		</footer>
	);
}
